import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trash2, Minus, Plus, ShoppingBag, ArrowRight, Tag, Gift } from 'lucide-react';
import Header from './components/Header23';
import Footer from './components/Footer23';

const Template23Cart = () => {
    const navigate = useNavigate();
    const [cartItems, setCartItems] = useState([
        {
            id: 1,
            name: 'Bridal Silk Lehenga',
            occasion: 'Wedding',
            size: 'M',
            price: 45999,
            quantity: 1,
            image: 'https://images.pexels.com/photos/8881954/pexels-photo-8881954.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 2,
            name: 'Sangeet Anarkali Set',
            occasion: 'Sangeet',
            size: 'S',
            price: 18500,
            quantity: 1,
            image: 'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 7,
            name: 'Diwali Kurta Set',
            occasion: 'Festive',
            size: 'L',
            price: 6800,
            quantity: 2,
            image: 'https://images.pexels.com/photos/17611651/pexels-photo-17611651.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
    ]);
    const [couponCode, setCouponCode] = useState('');
    const [couponApplied, setCouponApplied] = useState(false);

    const updateQuantity = (id, delta) => {
        setCartItems(prev => prev.map(item =>
            item.id === id
                ? { ...item, quantity: Math.max(1, item.quantity + delta) }
                : item
        ));
    };

    const removeItem = (id) => {
        setCartItems(prev => prev.filter(item => item.id !== id));
    };

    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const discount = couponApplied ? Math.round(subtotal * 0.1) : 0;
    const shipping = subtotal > 5000 ? 0 : 499;
    const total = subtotal - discount + shipping;

    const applyCoupon = () => {
        if (couponCode.trim().toUpperCase() === 'UTSAV10') {
            setCouponApplied(true);
        }
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Nunito+Sans:wght@300;400;500;600;700&display=swap');

                .utsav-cart-layout {
                    display: flex;
                    flex-direction: column;
                    gap: 32px;
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 120px 24px 80px;
                }
                @media (min-width: 768px) {
                    .utsav-cart-layout {
                        flex-direction: row;
                        gap: 48px;
                        padding: 140px 24px 80px;
                    }
                }
                .utsav-cart-items {
                    flex: 1;
                }
                .utsav-cart-summary {
                    width: 100%;
                }
                @media (min-width: 768px) {
                    .utsav-cart-summary {
                        width: 380px;
                        flex-shrink: 0;
                    }
                }
                .utsav-cart-item {
                    display: flex;
                    gap: 16px;
                }
                @media (min-width: 768px) {
                    .utsav-cart-item {
                        gap: 24px;
                    }
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FFFDF8' }}>
                <Header cartCount={cartItems.length} />

                {cartItems.length === 0 ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '180px 24px 100px',
                        maxWidth: '500px',
                        margin: '0 auto',
                    }}>
                        <div style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            backgroundColor: '#F8F3EC',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 24px',
                        }}>
                            <ShoppingBag size={32} color="#C5974B" />
                        </div>
                        <h2 style={{
                            fontFamily: "'Libre Baskerville', Georgia, serif",
                            fontSize: '24px',
                            fontWeight: 700,
                            color: '#1B3A2D',
                            margin: '0 0 12px 0',
                        }}>
                            Your Cart is Empty
                        </h2>
                        <p style={{
                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                            fontSize: '15px',
                            color: '#5A5A5A',
                            margin: '0 0 32px 0',
                            lineHeight: 1.6,
                        }}>
                            Begin your festive shopping journey. Explore our curated collection of celebration wear.
                        </p>
                        <button
                            onClick={() => navigate('/template23/shop')}
                            style={{
                                padding: '14px 40px',
                                backgroundColor: '#1B3A2D',
                                color: '#FFFFFF',
                                border: 'none',
                                borderRadius: '10px',
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '14px',
                                fontWeight: 700,
                                letterSpacing: '1px',
                                textTransform: 'uppercase',
                                cursor: 'pointer',
                            }}
                        >
                            Explore Collection
                        </button>
                    </div>
                ) : (
                    <div className="utsav-cart-layout">
                        {/* Cart Items */}
                        <div className="utsav-cart-items">
                            <h1 style={{
                                fontFamily: "'Libre Baskerville', Georgia, serif",
                                fontSize: 'clamp(24px, 3vw, 32px)',
                                fontWeight: 700,
                                color: '#1B3A2D',
                                margin: '0 0 8px 0',
                            }}>
                                Shopping Cart
                            </h1>
                            <p style={{
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '14px',
                                color: '#5A5A5A',
                                margin: '0 0 32px 0',
                            }}>
                                {cartItems.length} {cartItems.length === 1 ? 'item' : 'items'} in your cart
                            </p>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                {cartItems.map(item => (
                                    <div
                                        key={item.id}
                                        className="utsav-cart-item"
                                        style={{
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '12px',
                                            padding: '16px',
                                            boxShadow: '0 2px 12px rgba(27, 58, 45, 0.06)',
                                        }}
                                    >
                                        {/* Image */}
                                        <div
                                            onClick={() => navigate(`/template23/product/${item.id}`)}
                                            style={{
                                                width: '100px',
                                                height: '130px',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                flexShrink: 0,
                                                cursor: 'pointer',
                                                backgroundColor: '#F8F3EC',
                                            }}
                                        >
                                            <img
                                                src={item.image}
                                                alt={item.name}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                            />
                                        </div>

                                        {/* Details */}
                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                            <div>
                                                <span style={{
                                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                    fontSize: '10px',
                                                    fontWeight: 600,
                                                    color: '#C5974B',
                                                    letterSpacing: '1.5px',
                                                    textTransform: 'uppercase',
                                                }}>
                                                    {item.occasion}
                                                </span>
                                                <h3 style={{
                                                    fontFamily: "'Libre Baskerville', Georgia, serif",
                                                    fontSize: '16px',
                                                    fontWeight: 400,
                                                    color: '#1B3A2D',
                                                    margin: '4px 0 4px 0',
                                                }}>
                                                    {item.name}
                                                </h3>
                                                <p style={{
                                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                    fontSize: '13px',
                                                    color: '#5A5A5A',
                                                    margin: 0,
                                                }}>
                                                    Size: {item.size}
                                                </p>
                                            </div>

                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                marginTop: '12px',
                                            }}>
                                                {/* Quantity Controls */}
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    border: '1px solid #E8E0D4',
                                                    borderRadius: '8px',
                                                    overflow: 'hidden',
                                                }}>
                                                    <button
                                                        onClick={() => updateQuantity(item.id, -1)}
                                                        style={{
                                                            width: '32px',
                                                            height: '32px',
                                                            backgroundColor: '#F8F3EC',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        <Minus size={14} color="#1B3A2D" />
                                                    </button>
                                                    <span style={{
                                                        width: '36px',
                                                        textAlign: 'center',
                                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#1B3A2D',
                                                    }}>
                                                        {item.quantity}
                                                    </span>
                                                    <button
                                                        onClick={() => updateQuantity(item.id, 1)}
                                                        style={{
                                                            width: '32px',
                                                            height: '32px',
                                                            backgroundColor: '#F8F3EC',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        <Plus size={14} color="#1B3A2D" />
                                                    </button>
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                                    <span style={{
                                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                        fontSize: '16px',
                                                        fontWeight: 700,
                                                        color: '#C5974B',
                                                    }}>
                                                        {'\u20B9'}{(item.price * item.quantity).toLocaleString('en-IN')}
                                                    </span>
                                                    <button
                                                        onClick={() => removeItem(item.id)}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            padding: '4px',
                                                        }}
                                                    >
                                                        <Trash2 size={16} color="#7A1B3B" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Continue Shopping */}
                            <button
                                onClick={() => navigate('/template23/shop')}
                                style={{
                                    marginTop: '24px',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    color: '#1B3A2D',
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                    textUnderlineOffset: '4px',
                                }}
                            >
                                Continue Shopping
                            </button>
                        </div>

                        {/* Cart Summary */}
                        <div className="utsav-cart-summary">
                            <div style={{
                                backgroundColor: '#FFFFFF',
                                borderRadius: '16px',
                                padding: '28px',
                                boxShadow: '0 4px 20px rgba(27, 58, 45, 0.08)',
                                position: 'sticky',
                                top: '100px',
                            }}>
                                <h2 style={{
                                    fontFamily: "'Libre Baskerville', Georgia, serif",
                                    fontSize: '20px',
                                    fontWeight: 700,
                                    color: '#1B3A2D',
                                    margin: '0 0 24px 0',
                                }}>
                                    Order Summary
                                </h2>

                                {/* Coupon */}
                                <div style={{
                                    display: 'flex',
                                    gap: '8px',
                                    marginBottom: '24px',
                                }}>
                                    <div style={{
                                        flex: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        border: '1px solid #E8E0D4',
                                        borderRadius: '8px',
                                        padding: '0 12px',
                                        backgroundColor: '#FFFDF8',
                                    }}>
                                        <Tag size={14} color="#C5974B" />
                                        <input
                                            type="text"
                                            value={couponCode}
                                            onChange={(e) => setCouponCode(e.target.value)}
                                            placeholder="Coupon code"
                                            style={{
                                                flex: 1,
                                                border: 'none',
                                                outline: 'none',
                                                backgroundColor: 'transparent',
                                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#1B3A2D',
                                                padding: '12px 0',
                                            }}
                                        />
                                    </div>
                                    <button
                                        onClick={applyCoupon}
                                        style={{
                                            padding: '12px 20px',
                                            backgroundColor: '#1B3A2D',
                                            color: '#FFFFFF',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Apply
                                    </button>
                                </div>

                                {couponApplied && (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        backgroundColor: '#E8F5E9',
                                        padding: '10px 14px',
                                        borderRadius: '8px',
                                        marginBottom: '20px',
                                    }}>
                                        <Gift size={14} color="#1B3A2D" />
                                        <span style={{
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            color: '#1B3A2D',
                                        }}>
                                            UTSAV10 applied — 10% off!
                                        </span>
                                    </div>
                                )}

                                {/* Price Breakdown */}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#5A5A5A',
                                        }}>Subtotal</span>
                                        <span style={{
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            color: '#1B3A2D',
                                        }}>{'\u20B9'}{subtotal.toLocaleString('en-IN')}</span>
                                    </div>
                                    {couponApplied && (
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <span style={{
                                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#1B3A2D',
                                            }}>Discount (10%)</span>
                                            <span style={{
                                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                color: '#1B3A2D',
                                            }}>-{'\u20B9'}{discount.toLocaleString('en-IN')}</span>
                                        </div>
                                    )}
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#5A5A5A',
                                        }}>Shipping</span>
                                        <span style={{
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            color: shipping === 0 ? '#1B3A2D' : '#1B3A2D',
                                        }}>
                                            {shipping === 0 ? 'FREE' : `\u20B9${shipping}`}
                                        </span>
                                    </div>
                                </div>

                                <div style={{
                                    borderTop: '2px solid #E8E0D4',
                                    paddingTop: '16px',
                                    marginBottom: '24px',
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                                        <span style={{
                                            fontFamily: "'Libre Baskerville', Georgia, serif",
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            color: '#1B3A2D',
                                        }}>Total</span>
                                        <span style={{
                                            fontFamily: "'Libre Baskerville', Georgia, serif",
                                            fontSize: '22px',
                                            fontWeight: 700,
                                            color: '#C5974B',
                                        }}>{'\u20B9'}{total.toLocaleString('en-IN')}</span>
                                    </div>
                                </div>

                                <button
                                    onClick={() => navigate('/template23/checkout')}
                                    style={{
                                        width: '100%',
                                        padding: '16px',
                                        backgroundColor: '#C5974B',
                                        color: '#FFFFFF',
                                        border: 'none',
                                        borderRadius: '10px',
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '14px',
                                        fontWeight: 700,
                                        letterSpacing: '1px',
                                        textTransform: 'uppercase',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        transition: 'all 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#B8873F'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C5974B'; }}
                                >
                                    Proceed to Checkout
                                    <ArrowRight size={16} />
                                </button>

                                <div style={{
                                    textAlign: 'center',
                                    marginTop: '16px',
                                    padding: '12px',
                                    backgroundColor: '#F8F3EC',
                                    borderRadius: '8px',
                                }}>
                                    <p style={{
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '12px',
                                        color: '#5A5A5A',
                                        margin: 0,
                                    }}>
                                        {shipping > 0
                                            ? `Add \u20B9${(5000 - subtotal + discount).toLocaleString('en-IN')} more for free shipping`
                                            : 'You qualify for free shipping!'
                                        }
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer />
            </div>
        </>
    );
};

export default Template23Cart;
